/**
 * 大多数类型判断方法在lodash库中均存在，
 * 可参考lodash官方网站 https://www.lodashjs.com/
 *
 * 此处仅列出lodash不包含的相关类型判断方法
 */
import Vue from 'vue';

/**
 * 当前是否为服务端渲染模式
 */
const isSSR = () => Vue.prototype.$isServer;

export function isHtmlElement (node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

export const isDefined = val => {
  return val !== undefined && val !== null;
};

export const isIE = function () {
  return !isSSR() && !isNaN(Number(document.documentMode));
};

export const isEdge = function () {
  return !isSSR() && navigator.userAgent.indexOf('Edge') > -1;
};

export const isFirefox = function () {
  return !isSSR() && !!window.navigator.userAgent.match(/firefox/i);
};

export const isChromeBelow75 = function () {
  const matches = window.navigator.userAgent.match(/Chrome\/(\d+)\./);
  return matches && +matches[1] < 75;
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/xpc/types.js